import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";
import { format } from 'date-fns';
import { getInstallations } from "network/ApiAxios";

const AccountInformation = (props) => {
    const device = props.device
    const formDisabled = props.formDisabled
    const [license, setLicense] = useState()

    useEffect(() => {

        const runAsync = async () => {
            let params = {filter: {device: device._id}}

            const response = await getInstallations(params);
            const { data } = response;

            if (data.success) {
                setLicense(data.installation?.license._id)
            }

        }
        runAsync();
    }, [])

    let formatDate = () => {
        let date = ''

        if (device && device.date)
            date = format(device.date, "yyyy-MM-dd")

        return date
    }

    return (
        <>
            <hr className="my-4" />

            <h6 className="heading-small text-muted mb-4">Account Information</h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-creation"
                            >
                                Creation Date
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-creation"
                                defaultValue={formatDate()}
                                type="date"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-licenses"
                            >
                                License Key
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-licenses"
                                defaultValue={license}
                                type="text"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default AccountInformation